import { Link } from "react-router-dom";
import { GoArrowRight } from "react-icons/go";
import EventsSection from "./EventsSection";
import HeroVideo from "./HeroVideo";

import useHeroParallax from "../utils/useHeroParallax";

function Home() {
    const heroRef = useHeroParallax({ speedVideo: 0.3, speedText: 0.15 });
    return (
        <div className="home-page">
            <div id="hero" ref={heroRef}>
                <div id="hero-inner">
                    <div id="hero-text-group">
                        <h1 className="hero-text-b">Is Self-Inquiry</h1>
                        <p className="hero-text-c">bringing you</p>
                        <h1 className="hero-text-d">to Life?<img src="assets/arrow.png" alt="" /></h1>
                    </div>
                    <Link id="hero-inner-right" to="/vision">epiphanies-on-purpose</Link>
                </div>
                <HeroVideo />
            </div>
            <section id="second" className="section-band section-band--paper intro-section" aria-labelledby="second-title">
                <div className="container content-grid content-grid--media">
                    <div id="second_left" className="section-copy">
                        <h1 id="second-title" className="section-title">What are Living Rooms?</h1>
                        <p>Rather than calling them "workshops", we decided to go with something refreshing, exciting, yet intimate. Although Byron Katie doesn't call her method of self-inquiry "The Work" for nothing, we also wanted to highlight the idea that self-inquiry doesn't necessarily have to feel like work. In fact, moments of discovery can often times mimic play.</p>
                        <p>Additionally, the valuable insights that we glean from doing The Work don't just sit stagnant in our heads. Once awareness kicks in, we have no choice but to live out what we've discovered.</p>
                        <p>With these few points considered, we found that calling our workshops "Living Rooms" fit better. It's also a pretty awesome turnaround!</p>
                        <Link className="btn" data-variant="underline" to="/about">Learn more about us <GoArrowRight size={14} /></Link>
                    </div>

                    <div id="second_right" className="media-card media-frame">
                        <iframe
                            src="https://www.youtube.com/embed/n69XvXyAdFU?si=Bz3ApEz8Ce4iIVdn"
                            title="Living Rooms intro video"
                            loading="lazy"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                        />
                    </div>
                </div>
            </section>


            <section id="katie_vid_section" className="section-band section-band--bg centered-media-section" aria-labelledby="katie-title">
                <div className="container section-copy section-copy--center">
                    <h1 id="katie-title" className="section-title">A Moment With Katie...</h1>
                    <p className="body-copy">Check out when Katie joined us at The Work Runs Free back in early 2023!</p>
                    <div id="katie_vid" className="media-card media-frame media-frame--wide">
                        <iframe
                            src="https://www.youtube.com/embed/OCkhveA8DP4?si=bIgKWh7rQxTigBtv"
                            title="Katie Joins The Work Runs Free"
                            loading="lazy"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                        />
                    </div>
                </div>
            </section>

            <section id="third" className="section-band section-band--paper home-events" aria-labelledby="third-title">
                <header className="page-header home-section-header">
                    <h1 id="third-title" className="section-title">Events</h1>
                    <p className="page-subtitle">We have ongoing free events, and upcoming Living Rooms in planning!</p>
                </header>

                <div className="container events-cont">
                    <EventsSection maxEvents={3}></EventsSection>
                </div>
            </section>

        </div>
    );
}

export default Home;
